import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 24px;
  padding: 24px;
  background-color: ${props => props.theme.colors.primary};
`;

export const Div = styled.div`
  flex-wrap: wrap;
  align-items: flex-start;
  text-align: center;
  margin-right: 7%;
  .full-width {
    width: 100%;
  }
  .space-align-container {
    flex-wrap: wrap;
    align-items: flex-start;
    text-align: center;
    width: 100%;
  }
  .alert-button {
    color: #ffc14d;
    background: transparent;
    border-color: #ffc14d;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .alert-button:hover,
  .alert-button:focus {
    color: rgba(255, 193, 77, 0.5);
    border-color: rgba(255, 193, 77, 0.5);
  }
`;
